import CheckoutAddressCard from "./CheckoutAddressCard";

function IconUser() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 12a4.5 4.5 0 1 0-4.5-4.5A4.5 4.5 0 0 0 12 12zm0 2c-4.1 0-7.5 2.1-7.5 4.7V20h15v-1.3c0-2.6-3.4-4.7-7.5-4.7z"
      />
    </svg>
  );
}

function IconMail() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 4-8 5L4 8V6l8 5 8-5z"
      />
    </svg>
  );
}

function IconPhone() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M6.6 10.8a15.5 15.5 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.25 11.4 11.4 0 0 0 3.6.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1 11.4 11.4 0 0 0 .57 3.6 1 1 0 0 1-.25 1z"
      />
    </svg>
  );
}

function IconShield() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 2 4 5v6c0 5 3.4 9.7 8 11 4.6-1.3 8-6 8-11V5l-8-3zm0 4.1 5 1.9v3.9c0 3.5-2.2 6.8-5 8-2.8-1.2-5-4.5-5-8V8l5-1.9z"
      />
    </svg>
  );
}

const PHONE_PREFIX = "+36";

function getLocalPhone(phone) {
  const trimmed = String(phone || "").trim();
  if (trimmed.startsWith("+36")) return trimmed.slice(3).trimStart();
  if (trimmed.startsWith("36") && trimmed.length > 9) return trimmed.slice(2).trimStart();
  return trimmed;
}

function CheckoutContactStep({
  t,
  customer,
  onChange,
  shippingMethod,
  billingAddress,
  onBillingAddressChange,
}) {
  const localPhone = getLocalPhone(customer.phone);
  const showBillingAddress = shippingMethod === "pickup";

  function updateField(key, value) {
    onChange({ ...customer, [key]: value });
  }

  function updatePhone(localValue) {
    const cleaned = localValue.replace(/[^\d\s/-]/g, "");
    const next = cleaned.trim() ? `${PHONE_PREFIX} ${cleaned.trim()}` : "";
    updateField("phone", next);
  }

  return (
    <div className="checkout-contact">
      <header className="checkout-contact-intro">
        <h3 className="checkout-section-title">{t.contactHeading}</h3>
        <p className="checkout-step-hint">{t.contactHint}</p>
      </header>

      <div className="checkout-contact-card">
        <p className="checkout-contact-card-title">{t.contactSectionTitle}</p>

        <div className="checkout-contact-grid">
          <label className="checkout-field checkout-field--icon">
            <span>{t.nameLabel}</span>
            <span className="checkout-field-control">
              <span className="checkout-field-icon">
                <IconUser />
              </span>
              <input
                type="text"
                autoComplete="name"
                placeholder={t.namePlaceholder}
                value={customer.name}
                onChange={(event) => updateField("name", event.target.value)}
                required
              />
            </span>
          </label>

          <label className="checkout-field checkout-field--icon">
            <span>{t.emailLabel}</span>
            <span className="checkout-field-control">
              <span className="checkout-field-icon">
                <IconMail />
              </span>
              <input
                type="email"
                autoComplete="email"
                placeholder={t.emailPlaceholder}
                value={customer.email}
                onChange={(event) => updateField("email", event.target.value)}
                required
              />
            </span>
          </label>

          <label className="checkout-field checkout-field--icon checkout-field--phone">
            <span>{t.phoneLabel}</span>
            <span className="checkout-phone-row">
              <span className="checkout-phone-prefix" aria-hidden="true">
                {PHONE_PREFIX}
                <span className="checkout-phone-prefix-chevron" />
              </span>
              <span className="checkout-field-control">
                <span className="checkout-field-icon">
                  <IconPhone />
                </span>
                <input
                  type="tel"
                  autoComplete="tel-national"
                  inputMode="tel"
                  placeholder={t.phonePlaceholder}
                  value={localPhone}
                  onChange={(event) => updatePhone(event.target.value)}
                  required
                />
              </span>
            </span>
          </label>
        </div>

        {!showBillingAddress ? (
          <div className="checkout-contact-footer">
            <p className="checkout-contact-privacy">
              <IconShield />
              <span>{t.contactPrivacy}</span>
            </p>
            <p className="checkout-contact-required">{t.requiredFields}</p>
          </div>
        ) : null}
      </div>

      {showBillingAddress ? (
        <CheckoutAddressCard
          t={t}
          address={billingAddress}
          onChange={onBillingAddressChange}
          sectionTitle={t.billingSectionTitle}
        />
      ) : null}
    </div>
  );
}

export default CheckoutContactStep;
